<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Rd04o4/images/9781460338957_fmt.jpeg?1693516336200" alt="This image is the cover for the book Pirate Hunter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pirate Hunter
      </h1>
      <p class="bookDescription body article font2">
        <b>A forbidden attraction in paradise between a British aristocrat and a pirate’s sister propels this action-packed, Caribbean-set romantic adventure.</b><br/><br/>Shipwrecked off the coast of Barbados, pirate hunter William Greenacre is ready to surrender to the seductive pull of the sea when an angelic figure dives to his rescue. Except this angel is none other than Mia Del Torres—and she’s a wanted woman!<br/><br/>To escape imprisonment, Mia must set sail with Will on his mission of revenge and help track down her brother, the formidable Captain Jorge Del Torres. By rights, she should hate Will, yet below deck their passion ignites. But when the hunters become the hunted, will their newly forged connection be enough to save them both?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laura Martin
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c82bd1be